// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__20AUT","label":"Section_label__2-sHY","contentWrap":"Section_contentWrap__1hfAl","footer":"Section_footer__2dqvb","footerInner":"Section_footerInner__2CB7A"};